import { listDepartmentsStart } from '../list-departments/actions';
import { takeLatest, call, put } from 'redux-saga/effects';

import { loading, success, failure } from './slice';
import { createDepartmentStart } from './actions';
import { createDepartment } from './service';
import { history } from 'redux/store';
import { Action } from '@reduxjs/toolkit';

function* createDepartmentFlow(action: Action<unknown>) {
  if (createDepartmentStart.match(action)) {
    try {
      yield put(loading());
      yield call(createDepartment, action.payload);
      yield put(success());
      yield put(listDepartmentsStart({ organizationId: action.payload.organizationId }));
      yield history.push(history.location);
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export function* onCreateDepartmentStart() {
  yield takeLatest(createDepartmentStart, createDepartmentFlow);
}
